/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { saveAs } from 'file-saver';
import { apiGet } from '../../utils/apiClient';
import DownloadFileIcon from '@mui/icons-material/Download';
import { notifyActionSuccess, notifyFailure } from '../../utils/toast';
import { useTranslation } from '../../i18n';

const DownloadExcelTemplateButton: React.FC = () => {
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);

    try {
      const response = await apiGet('/registration/download-excel-template', {
        responseType: 'blob',
      });

      const blob = new Blob([response as any], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, 'aquatics-hub_registration_template.xlsx');

      notifyActionSuccess('Template downloaded successfully!');
    } catch (error) {
      console.error('Failed to download the template');
      notifyFailure();
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-2">
      <Button
        variant="outlined"
        color="primary"
        onClick={handleDownload}
        disabled={downloading}
        startIcon={<DownloadFileIcon />}
        className="border-blue-600 text-blue-600 hover:bg-blue-50 font-semibold py-2 px-4 rounded"
      >
        {downloading ? (
          <CircularProgress size={24} className="text-blue-600" />
        ) : (
          t('registration.downloadExcelTemplate')
        )}
      </Button>
    </div>
  );
};

export default DownloadExcelTemplateButton;
